import { Autoplay, Controller, EffectFade, Navigation, Pagination, Thumbs, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, Thumbs]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  setMV()
  setAbout()
  setInterview()
  setProjects()
  setData()
}

/**
 * MV関連のセットアップ
 */
function setMV() {
  /**
   * MV
   */
  const mv = document.querySelector('.topMv')
  const bg = document.querySelector('.topMv__bg')
  const phs = document.querySelectorAll('.topMv__ph')

  const state = {
    current: 0,
    currentMax: phs.length,
    progress: 0,
    speed: 0.002,
  }

  const fadeSpeed = 0.1
  let init = false

  const update = () => {
    state.progress += state.speed
    if (state.progress > 1) {
      state.current = (state.current + 1) % state.currentMax
      state.progress = 0
    }

    phs.forEach((ph, index) => {
      const { current, currentMax, progress } = state

      const currentNext = (current + 1) % currentMax
      const ratioScale = Math.min(progress, 1)

      if (index == current) {
        ph.style.scale = 1 + 0.2 * ratioScale
        ph.style.zIndex = 3
      } else {
        ph.style.scale = 1
        ph.style.zIndex = index == currentNext ? 2 : 1
      }
    })

    const fadeIn = Math.max(Math.min(state.progress / fadeSpeed, 1), 0)
    const fadeOut = 1 - Math.max(Math.min((state.progress - (1 - fadeSpeed)) / fadeSpeed, 1), 0)

    if (state.progress < 0.5) {
      bg.style.opacity = fadeIn
    } else {
      bg.style.opacity = fadeOut
    }

    if (!init && fadeIn == 1) {
      mv.classList.add('animated')
      init = true
    }

    requestAnimationFrame(update)
  }
  update()

  /**
   * NEWS
   */
  // トップページのみで使うSwiper群を初期化
  const newsSlider = document.querySelector('.js-slider-news')
  const newsPagination = document.querySelector('.js-slider-news-pagination')

  if (newsSlider) {
    // NEWSは縦方向に自動スライド（1件表示）
    const options = {
      slidesPerView: 1,
      direction: 'vertical',
      speed: 600,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    }

    if (newsPagination) {
      // ページャーがある場合のみfraction表示
      options.pagination = {
        el: newsPagination,
        type: 'fraction',
      }
    }

    new Swiper(newsSlider, {
      ...options,
    })
  }
}

/**
 * ABOUT US関連のセットアップ
 */
function setAbout() {
  const list = document.querySelector('.topAbout__list')
  const panels = document.querySelectorAll('.topAbout__itemPanel')
  const btns = document.querySelectorAll('.topAbout__itemContentBtn')

  panels.forEach((panel, index) => {
    panel.addEventListener('click', () => {
      if (list.dataset.current == 0) {
        list.dataset.current = index + 1
      } else {
        list.dataset.current = 0
      }
    })
  })

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      list.dataset.current = 0
    })
  })
}

/**
 * OUR PROJECTS関連のセットアップ
 */
function setProjects() {
  const items = document.querySelectorAll('.topProjects__item')
  items.forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('is_active')
    })
  })
}

/**
 * INTERVIEW関連のセットアップ
 */
function setInterview() {
  const voicePhoto = document.querySelector('.js-slider-voice-photo')
  const voiceInfo = document.querySelector('.js-slider-voice-info')
  const voiceCard = document.querySelector('.js-slider-voice-card')
  const voicePrev = document.querySelector('.js-slider-voice-prev')
  const voiceNext = document.querySelector('.js-slider-voice-next')
  const voicePagination = document.querySelector('.js-slider-voice-pagination')

  const InterviewSlide01 = new Swiper(voiceInfo, {
    speed: 800,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
  })

  const InterviewSlide01PCThum = new Swiper(voiceCard, {
    speed: 800,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 8,
    loop: true,
    loopAdditionalSlides: 12,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    on: {
      init(swiper) {
        swiper.__clickLocked = false
      },
      click(swiper) {
        if (swiper.__clickLocked) {
          return
        }
        if (swiper.clickedIndex == null) {
          return
        }
        swiper.__clickLocked = true
        // console.log('InterviewSlide01PCThum click', swiper.clickedIndex, swiper.clickedSlide)
        swiper.slideTo(swiper.clickedIndex)
      },
      slideChangeTransitionStart(swiper) {
        swiper.__clickLocked = true
      },
      slideChangeTransitionEnd(swiper) {
        let targetIndex = swiper.activeIndex
        if (targetIndex < 6) {
          targetIndex += 6
        } else if (targetIndex >= 12) {
          targetIndex -= 6
        }
        if (targetIndex !== swiper.activeIndex) {
          swiper.slideTo(targetIndex, 0, false)
        }
        swiper.update()
        swiper.__clickLocked = false
      },
    },
    thumbs: {
      swiper: InterviewSlide01,
    },
    breakpoints: {
      769: {
        spaceBetween: 16,
      },
    },
  })

  const InterviewSlide01Thum = new Swiper(voicePhoto, {
    speed: 800,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 12,
    allowTouchMove: true,
    watchOverflow: true,
    autoplay: {
      disableOnInteraction: false,
      waitForTransition: true,
      delay: 5000,
    },
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: InterviewSlide01PCThum,
    },
    pagination: {
      el: voicePagination,
      type: 'fraction',
    },
    navigation: {
      nextEl: voiceNext,
      prevEl: voicePrev,
    },
  })

  /**
   * VIEW MORE
   */
  const viewMores = document.querySelectorAll('.topInterview__voiceInfoMore')

  const modal = document.querySelector('.modal')
  const modals = document.querySelectorAll('.topVoice')
  const modalDown = document.querySelectorAll('.topVoice__down')

  viewMores.forEach((more) => {
    const id = more.dataset.id
    more.addEventListener('click', (e) => {
      e.preventDefault()

      modals.forEach((modal) => {
        if (modal.dataset.id == id) {
          modal.classList.remove('is_hide')
        } else {
          modal.classList.add('is_hide')
        }
      })

      modal.scrollTop = 0
      document.body.classList.add('is_modal')
    })
  })

  modalDown.forEach((btn) => {
    const parent = btn.closest('.topVoice')
    const content = parent.querySelector('.topVoice__lists')

    btn.addEventListener('click', () => {
      const rect = content.getBoundingClientRect()
      const style = window.getComputedStyle(content)
      const top = rect.top - parseFloat(style.marginTop)

      modal.scrollBy({
        top: top,
        left: 0,
        behavior: 'smooth',
      })
    })
  })

  document.querySelector('.modal__closeBtn').addEventListener('click', () => {
    document.body.classList.remove('is_modal')
  })

  document.querySelectorAll('.topVoice__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.body.classList.remove('is_modal')
    })
  })
}

/**
 * DATA関連のセットアップ
 */
function setData() {
  const numbersElm = document.querySelectorAll('.topData__cardNumber')
  const numbers = []
  const progressSpeed = 0.01
  let finishCount = 0

  /**
   * 数値フォーマット
   */
  const formatNumber = (value, isDecimal, digitCount) => {
    if (isDecimal) {
      const fixed = value.toFixed(1)
      const parts = fixed.split('.')
      const targetLength = Math.max(1, digitCount - 1)
      const paddedInt = parts[0].padStart(targetLength, '0')
      return `${paddedInt}.${parts[1]}`
    }

    const intValue = Math.floor(value)
    const targetLength = Math.max(1, digitCount)
    return String(intValue).padStart(targetLength, '0')
  }

  /**
   * イージング
   */
  const easeOutCubic = (x) => {
    return 1 - Math.pow(1 - x, 3)
  }

  const easeOutCirc = (x) => {
    return Math.sqrt(1 - Math.pow(x - 1, 2))
  }

  /**
   * 初期設定
   */
  numbersElm.forEach((elm) => {
    const number = elm.textContent.trim()
    const normalized = number.replace(/,/g, '')
    const isDecimal = normalized.includes('.')
    const digitCount = normalized.replace(/\D/g, '').length
    elm.textContent = formatNumber(0, isDecimal, digitCount)

    numbers.push({
      elm,
      numberMax: number,
      isDecimal,
      digitCount,
      progress: 0,
      running: false,
      finished: false,
    })
  })

  /**
   * 更新処理
   */
  const update = () => {
    numbers.forEach((number) => {
      const { elm, numberMax, isDecimal, digitCount, running, finished } = number

      if (!running && !finished) {
        const rect = elm.getBoundingClientRect()
        const isInView = rect.top < window.innerHeight && rect.bottom > 0
        if (isInView) {
          number.running = true
        }
      } else if (!finished) {
        number.progress = Math.min(number.progress + progressSpeed, 1)
        const ease = easeOutCirc(number.progress)

        const maxValue = parseFloat(String(numberMax).replace(/,/g, ''))
        const current = maxValue * ease
        elm.textContent = formatNumber(current, isDecimal, digitCount)

        const card = elm.closest('.topData__card')
        const bg = card ? card.querySelector('.topData__cardBg') : null
        if (bg) {
          bg.style.clipPath = `inset(${100 * (1 - ease)}% 0% 0%)`
        }

        if (number.progress === 1) {
          number.finished = true
          finishCount++
        }
      }
    })

    if (numbers.length != finishCount) {
      requestAnimationFrame(update)
    }
  }
  update()
}
